// extracted by mini-css-extract-plugin
export default {"container":"NonCompliantCheckbox_container__XFW-h"};